import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';
import { getOnlyToken } from '../../utils/commonFunctions';
import { FaCheckCircle, FaClock, FaEnvelope, FaTimesCircle } from "react-icons/fa";
import { useForm } from 'react-hook-form';
import { Modal, Button, Spinner } from "react-bootstrap";
import { BsThreeDotsVertical } from "react-icons/bs";
const Customerinfo = () => {
    const { customerId } = useParams();
    const navigate = useNavigate();
    const audioRef = useRef(null);
    const [customerData, setCustomerData] = useState(null);
    const [dashboardData, setDashboardData] = useState({});
    const [conversationData, setConversationData] = useState({});
    const [messageData, setMessageData] = useState({});
    const [loading, setLoading] = useState(true);
    const [selectedConversation, setSelectedConversation] = useState(null);
    const [startDate, setStartDate] = useState(moment().subtract(30, 'days').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment().format('YYYY-MM-DD'));
    const [status, setStatus] = useState('')
    const { register, handleSubmit, reset, getValues, setValue, formState: { errors }, } = useForm();
    const [submitLoading, setSubmitLoading] = useState(false);
    const [openModal, setOpenModal] = useState(false)
    const [agents, setAgents] = useState([]);
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef();
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    // Close dropdown on outside click
    useEffect(() => {
        const handleClick = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClick);
        return () => document.removeEventListener("mousedown", handleClick);
    }, []);

    const fetchCustomerData = async () => {
        setLoading(true);
        const token = getOnlyToken();
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        };

        try {
            const response = await axios.get(
                `/api/agents/customer-call-conversation/?target_customer_id=${customerId}&start_date=${startDate}&end_date=${endDate}`,
                config
            );

            if (response.data && response.data.status_code === 200) {
                setCustomerData(response.data.customer_profile[0]);
                setDashboardData(response.data.dashboard_data);
                setMessageData(response.data.messages_breakdown);
                setConversationData(response.data.data);
                setStatus(response.data.consent_status)
                setTimeout(() => {
                    setValue("target_lead_name", response.data.customer_profile[0].target_lead_name)
                    setValue("target_lead_email", response.data.customer_profile[0].target_lead_email)
                    setValue("target_lead_phone", response.data.customer_profile[0].target_lead_phone)
                    setValue("target_lead_company", response.data.customer_profile[0].target_lead_company)
                    setValue("target_company_website", response.data.customer_profile[0].target_company_website)
                    setValue("agent", response.data.customer_profile[0].selected_agent_id)
                    setValue("target_company_info", response.data.customer_profile[0].target_company_info)

                }, 2000);

            }
        } catch (error) {
            console.error('Error fetching customer data:', error);
        } finally {
            setLoading(false);
        }
    };

    const onloadvalues = (data) => {
        setTimeout(() => {
            setValue("target_lead_name", data.target_lead_name)
            setValue("target_lead_email", data.target_lead_email)
            setValue("target_lead_phone", data.target_lead_phone)
            setValue("target_lead_company", data.target_lead_company)
            setValue("target_company_website", data.target_company_website)
            setValue("agent", data.selected_agent_id)
            setValue("target_company_info", data.target_company_info)
        }, 200);

    }

    useEffect(() => {
        if (customerId) {
            fetchCustomerData();
        }
    }, [customerId, startDate, endDate]);

    const formatDuration = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
    };

    const getMessageBreakdown = () => {
        let aiMessages = 0;
        let userMessages = 0;

        Object.values(conversationData).forEach(conv => {
            if (Array.isArray(conv.conversation)) {
                conv.conversation.forEach(msg => {
                    if (msg.role === 'ai') aiMessages++;
                    else userMessages++;
                });
            }
        });

        return { aiMessages, userMessages };
    };

    const handleModalClose = () => {
        // Stop audio playback when modal closes
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
        }
    };

    // Add event listener for modal close events
    useEffect(() => {
        const modalElement = document.getElementById('conversationModal');
        if (modalElement) {
            modalElement.addEventListener('hidden.bs.modal', handleModalClose);
            return () => {
                modalElement.removeEventListener('hidden.bs.modal', handleModalClose);
            };
        }
    }, []);


    const handleClose = () => {

        setOpenModal(false);
        reset();
    };
    const handledeleteClose = () => {

        setShowDeleteModal(false);

    };
    const fetchAgents = async () => {
        const token = getOnlyToken();
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        };

        try {
            const resp = await axios.get('/api/agents/dropdown/', config);
            if (resp && resp.data && resp.data.status_code === 200) {
                setAgents(resp.data.data || []);
                console.log('Agents loaded:', resp.data.data?.length || 0);
            } else {
                console.warn('Unexpected agents response', resp);
            }
        } catch (err) {
            console.error('Error fetching agents dropdown:', err);
        }
    };

    const handleGenerateInfo = async () => {
        const companyName = getValues("target_lead_company");
        const companyWebsite = getValues("target_company_website");

        if (!companyName || !companyWebsite) {
            alert("Please fill in Company Name and Company Website before generating info.");
            return;
        }

        const token = getOnlyToken();
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        };

        try {
            setLoading(true);

            const response = await axios.post(`/api/agents/company-info-gen/`,
                {
                    company_name: companyName,
                    company_website: companyWebsite,
                },
                config
            );
            const companyInfo = response.data?.Company_info?.[0]?.company_info;

            if (companyInfo) {
                setValue("target_company_info", companyInfo);
            } else {
                alert("No company info found in the response.");
            }
        } catch (error) {
            alert("Failed to generate company info. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const onSubmit = async (data) => {
        const token = getOnlyToken();
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        };

        const payload = {
            target_customer_id: customerId,
            target_lead_name: data.target_lead_name,
            target_lead_email: data.target_lead_email,
            target_lead_phone: data.target_lead_phone,
            target_lead_company: data.target_lead_company,
            target_company_website: data.target_company_website,
            target_company_info: data.target_company_info,
            agent_id: data.agent ? parseInt(data.agent) : null,
        };

        try {
            setSubmitLoading(true);
            const resp = await axios.put("/api/agents/target-customer/update/", payload, config);
            navigate(-1)

        } catch (err) {

        } finally {
            setSubmitLoading(false);

        }
    };

    const handleDelete = async () => {
        const token = getOnlyToken();
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        };
        try {
            setLoading(true);
            const response = await axios.delete(`/api/agents/target-customer/delete/?customer_id=${customerId}`, config);
            navigate(-1)
            setOpen(false); // close dropdown
        } catch (error) {

        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchAgents()
    }, [])

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    if (!customerData) {
        return (
            <div className="container mt-5">
                <div className="alert alert-warning">Customer data not found.</div>
            </div>
        );
    }

    return (
        <>
            <div className="container-fluid">
                {/* Page Title */}
                <div className="mb-3">
                    <h2 className="text-white fw-bold mb-0" style={{ fontSize: '28px' }}>User Call Record</h2>
                </div>

                {/* Header */}
                <div className="d-flex align-items-center mb-4">
                    <button
                        className="btn btn-success me-3 fw-semibold"
                        onClick={() => navigate(-1)}
                        style={{
                            fontSize: '16px',
                            padding: '10px 20px',
                            border: '2px solid #28a745',
                            backgroundColor: '#28a745'
                        }}
                    >
                        ← Back to Customers
                    </button>
                </div>

                {/* Customer Profile Header */}
                <div className="card mb-4" style={{ backgroundColor: '#1a2332', border: '1px solid #2d3748' }}>
                    <div className="card-body p-4">
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                                <div>
                                    <h3 className="text-white mb-1" style={{ fontSize: '24px' }}>{customerData.target_lead_name}</h3>
                                    <p className="text-info mb-0" style={{ fontSize: '18px' }}>@ {customerData.target_lead_company}</p>
                                    <span className="badge bg-success" style={{ fontSize: '14px' }}>Active</span>
                                </div>
                            </div>
                            <div className="d-flex gap-2">


                                <span
                                    className="badge fs-5 d-inline-flex align-items-center gap-1"
                                    style={{
                                        backgroundColor:
                                            status?.toLowerCase() === "accepted"
                                                ? "rgba(40,167,69,0.1)"
                                                : status?.toLowerCase() === "pending"
                                                    ? "rgba(255,193,7,0.15)"
                                                    : status?.toLowerCase() === "not sent"
                                                        ? "rgba(151,179,240,0.1)"
                                                        : "rgba(220,53,69,0.1)",
                                        color:
                                            status?.toLowerCase() === "accepted"
                                                ? "#28a745"
                                                : status?.toLowerCase() === "pending"
                                                    ? "#ffc107"
                                                    : status?.toLowerCase() === "not sent"
                                                        ? "#6290e6ff"
                                                        : "#dc3545",
                                        borderRadius: "12px",
                                        padding: "6px 10px",
                                        textTransform: "capitalize",
                                    }}
                                >
                                    {status?.toLowerCase() === "accepted" && <FaCheckCircle />}
                                    {status?.toLowerCase() === "pending" && <FaClock />}
                                    {status?.toLowerCase() === "not sent" && <FaEnvelope />}
                                    {status?.toLowerCase() === "rejected" && <FaTimesCircle />}

                                    <span>{status}</span>

                                    <div style={{ position: "relative" }} ref={dropdownRef}>
                                        <div
                                            onClick={() => setOpen(!open)}
                                            style={{
                                                cursor: "pointer",
                                                padding: "6px",
                                                borderRadius: "8px",
                                                transition: "0.2s",
                                            }}
                                            onMouseEnter={(e) => (e.target.style.background = "#2c3545")}
                                            onMouseLeave={(e) => (e.target.style.background = "transparent")}
                                        >
                                            <BsThreeDotsVertical size={18} color="#cbd5e1"  />
                                        </div>

                                        {/* DROPDOWN MENU */}
                                        {open && (
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    right: 0,
                                                    top: "30px",
                                                    background: "#334155",
                                                    borderRadius: "6px",
                                                    boxShadow: "0px 4px 10px rgba(0,0,0,0.3)",
                                                    width: "120px",
                                                    overflow: "hidden",
                                                    zIndex: 20,
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        padding: "10px 12px",
                                                        cursor: "pointer",
                                                        fontSize: "14px",
                                                    }}
                                                    onMouseEnter={(e) => (e.target.style.background = "#475569")}
                                                    onMouseLeave={(e) => (e.target.style.background = "transparent")}
                                                    onClick={() => { setOpenModal(true); setOpen(false);onloadvalues(customerData) }}>
                                                    Edit
                                                </div>

                                                <div
                                                    style={{
                                                        padding: "10px 12px",
                                                        cursor: "pointer",
                                                        fontSize: "14px",
                                                        color: "#f87171",
                                                    }}
                                                    onMouseEnter={(e) => (e.target.style.background = "#475569")}
                                                    onMouseLeave={(e) => (e.target.style.background = "transparent")}
                                                    onClick={() => { setShowDeleteModal(true); setOpen(false) }}>
                                                    Delete
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </span>

                                <button className="btn btn-outline-light" style={{ fontSize: '15px' }}>
                                    <i className="ri-more-line"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Dashboard Cards */}
                <div className="row mb-4">
                    <div className="col-md-3">
                        <div className="card h-100" style={{ backgroundColor: '#1a2332', border: '1px solid #2d3748' }}>
                            <div className="card-body">
                                <div className="d-flex align-items-center">
                                    <div className="me-3">
                                        <i className="ri-phone-line text-info" style={{ fontSize: '24px' }}></i>
                                    </div>
                                    <div>
                                        <h4 className="text-white mb-0" style={{ fontSize: '22px' }}>{dashboardData.total_calls}</h4>
                                        <small className="text-muted" style={{ fontSize: '14px' }}>Total Calls</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card h-100" style={{ backgroundColor: '#1a2332', border: '1px solid #2d3748' }}>
                            <div className="card-body">
                                <div className="d-flex align-items-center">
                                    <div className="me-3">
                                        <i className="ri-checkbox-circle-line text-success" style={{ fontSize: '24px' }}></i>
                                    </div>
                                    <div>
                                        <h4 className="text-white mb-0" style={{ fontSize: '22px' }}>{dashboardData.success_calls}</h4>
                                        <small className="text-muted" style={{ fontSize: '14px' }}>Successful Calls</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card h-100" style={{ backgroundColor: '#1a2332', border: '1px solid #2d3748' }}>
                            <div className="card-body">
                                <div className="d-flex align-items-center">
                                    <div className="me-3">
                                        <i className="ri-timer-line text-primary" style={{ fontSize: '24px' }}></i>
                                    </div>
                                    <div>
                                        <h4 className="text-white mb-0" style={{ fontSize: '22px' }}>{dashboardData.total_duration}</h4>
                                        <small className="text-muted" style={{ fontSize: '14px' }}>Total Duration</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="card h-100" style={{ backgroundColor: '#1a2332', border: '1px solid #2d3748' }}>
                            <div className="card-body">
                                <div className="d-flex align-items-center">
                                    <div className="me-3">
                                        <i className="ri-line-chart-line text-warning" style={{ fontSize: '24px' }}></i>
                                    </div>
                                    <div>
                                        <h4 className="text-white mb-0" style={{ fontSize: '22px' }}>{dashboardData.success_percentage?.toFixed(1) || 0}%</h4>
                                        <small className="text-muted" style={{ fontSize: '14px' }}>Success Rate</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Content Sections */}
                <div className="row">
                    {/* Contact Information */}
                    <div className="col-md-6">
                        <div className="card mb-4" style={{ backgroundColor: '#1a2332', border: '1px solid #2d3748' }}>
                            <div className="card-body">
                                <h5 className="text-success mb-3" style={{ fontSize: '20px' }}>
                                    <i className="ri-contacts-line me-2"></i>Contact Information
                                </h5>
                                <div className="mb-3">
                                    <strong className="text-white" style={{ fontSize: '16px' }}>Email</strong>
                                    <p className="text-muted mb-0" style={{ fontSize: '16px' }}>{customerData.target_lead_email}</p>
                                </div>
                                <div className="mb-3">
                                    <strong className="text-white" style={{ fontSize: '16px' }}>Phone</strong>
                                    <p className="text-muted mb-0" style={{ fontSize: '16px' }}>{customerData.target_lead_phone}</p>
                                </div>
                                <div className="mb-3">
                                    <strong className="text-white" style={{ fontSize: '16px' }}>Total Calls</strong>
                                    <p className="text-white mb-0" style={{ fontSize: '16px' }}>{dashboardData.total_calls || 0}</p>
                                </div>
                                <div className="mb-3">
                                    <strong className="text-white" style={{ fontSize: '16px' }}>Last Call</strong>
                                    <p className="text-muted mb-0" style={{ fontSize: '16px' }}>
                                        {Object.keys(conversationData).length > 0
                                            ? moment(Object.keys(conversationData)[0]).format('MMM DD, YYYY hh:mm A')
                                            : 'No calls yet'
                                        }
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Company Information */}
                    <div className="col-md-6">
                        <div className="card mb-4" style={{ backgroundColor: '#1a2332', border: '1px solid #2d3748' }}>
                            <div className="card-body">
                                <h5 className="text-success mb-3" style={{ fontSize: '20px' }}>
                                    <i className="ri-building-line me-2"></i>Company Information
                                </h5>
                                <div className="mb-3">
                                    <strong className="text-white" style={{ fontSize: '16px' }}>Company Name</strong>
                                    <p className="text-muted mb-0" style={{ fontSize: '16px' }}>{customerData.target_lead_company}</p>
                                </div>
                                <div className="mb-3">
                                    <strong className="text-white" style={{ fontSize: '16px' }}>Website</strong>
                                    <p className="text-muted mb-0" style={{ fontSize: '16px' }}>
                                        {customerData.target_company_website ? (
                                            <a href={customerData.target_company_website} target="_blank" rel="noopener noreferrer" className="text-info">
                                                {customerData.target_company_website}
                                            </a>
                                        ) : (
                                            'No website available'
                                        )}
                                    </p>
                                </div>
                                <div className="mb-3">
                                    <strong className="text-white" style={{ fontSize: '16px' }}>Company Description</strong>
                                    <div
                                        className="text-muted"
                                        style={{
                                            maxHeight: '150px',
                                            overflowY: 'auto',
                                            fontSize: '15px',
                                            lineHeight: '1.5'
                                        }}
                                    >
                                        {customerData.target_company_info ? (
                                            <div dangerouslySetInnerHTML={{
                                                __html: customerData.target_company_info.replace(/\n/g, '<br/>')
                                            }} />
                                        ) : (
                                            'No company information available'
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Message Breakdown and Conversation History */}
                <div className="row">
                    {/* Message Breakdown */}
                    <div className="col-md-6">
                        <div className="card mb-4" style={{ backgroundColor: '#1a2332', border: '1px solid #2d3748' }}>
                            <div className="card-body">
                                <h5 className="text-success mb-3" style={{ fontSize: '20px' }}>
                                    <i className="ri-bar-chart-line me-2"></i>Message Breakdown
                                </h5>
                                {messageData.ai_messages + messageData.user_messages > 0 ? (
                                    <>
                                        <div className="mb-3">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span className="text-white" style={{ fontSize: '16px' }}>AI Messages</span>
                                                <span className="text-white" style={{ fontSize: '16px' }}>{messageData.ai_messages}</span>
                                            </div>
                                            <div className="progress" style={{ height: '8px' }}>
                                                <div
                                                    className="progress-bar bg-info"
                                                    style={{
                                                        width: `${(messageData.ai_messages / (messageData.ai_messages + messageData.user_messages)) * 100}%`
                                                    }}
                                                ></div>
                                            </div>
                                        </div>
                                        <div className="mb-3">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span className="text-white" style={{ fontSize: '16px' }}>User Messages</span>
                                                <span className="text-white" style={{ fontSize: '16px' }}>{messageData.user_messages}</span>
                                            </div>
                                            <div className="progress" style={{ height: '8px' }}>
                                                <div
                                                    className="progress-bar bg-success"
                                                    style={{
                                                        width: `${(messageData.user_messages / (messageData.ai_messages + messageData.user_messages)) * 100}%`
                                                    }}
                                                ></div>
                                            </div>
                                        </div>
                                        <div className="mb-3">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span className="text-white" style={{ fontSize: '16px' }}>AI Response Rate</span>
                                                <span className="text-white" style={{ fontSize: '16px' }}>{(messageData.ai_response_rate)}%</span>
                                            </div>
                                            <div className="progress" style={{ height: '8px' }}>
                                                <div
                                                    className="progress-bar bg-warning"
                                                    style={{
                                                        width: `${(messageData.ai_response_rate / (messageData.ai_messages + messageData.user_messages)) * 100}%`
                                                    }}
                                                ></div>
                                            </div>
                                        </div>
                                        <div>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span className="text-white" style={{ fontSize: '16px' }}>User Engagement</span>
                                                <span className="text-white" style={{ fontSize: '16px' }}>{(messageData.user_engagement_rate)}%</span>
                                            </div>
                                            <div className="progress" style={{ height: '8px' }}>
                                                <div
                                                    className="progress-bar bg-primary"
                                                    style={{
                                                        width: `${(messageData.user_engagement_rate / (messageData.ai_messages + messageData.user_messages)) * 100}%`
                                                    }}
                                                ></div>
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <p className="text-muted" style={{ fontSize: '16px' }}>No message data available</p>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Conversation History */}
                    <div className="col-md-6">
                        <div className="card mb-4" style={{ backgroundColor: '#1a2332', border: '1px solid #2d3748' }}>
                            <div className="card-body">
                                <h5 className="text-success mb-3" style={{ fontSize: '20px' }}>
                                    <i className="ri-history-line me-2"></i>Conversation History
                                </h5>
                                <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                    {Object.keys(conversationData).length > 0 ? (
                                        Object.entries(conversationData).map(([date, conv], index) => (
                                            <div key={index} className="mb-3 p-3 rounded" style={{ backgroundColor: '#0f1419' }}>
                                                <div className="d-flex justify-content-between align-items-center mb-2">
                                                    <small className="text-info" style={{ fontSize: '14px' }}>
                                                        {moment(date).format('MMM DD, YYYY hh:mm A')}
                                                    </small>
                                                    <div className="d-flex gap-2">
                                                        <span className="badge bg-primary" style={{ fontSize: '12px' }}>
                                                            {Array.isArray(conv.conversation) ? conv.conversation.length : 0} messages
                                                        </span>
                                                        <span className="badge bg-success" style={{ fontSize: '12px' }}>Active</span>
                                                    </div>
                                                </div>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div>
                                                        {Array.isArray(conv.conversation) && conv.conversation.length > 0 ? (
                                                            <p className="text-muted mb-0" style={{ fontSize: '15px' }}>
                                                                {conv.conversation[0].content.substring(0, 100)}...
                                                            </p>
                                                        ) : (
                                                            <p className="text-muted mb-0" style={{ fontSize: '15px' }}>No conversation available</p>
                                                        )}
                                                    </div>
                                                    <button
                                                        className="btn btn-sm btn-outline-info"
                                                        onClick={() => setSelectedConversation({ date, ...conv })}
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#conversationModal"
                                                        style={{ fontSize: '14px' }}
                                                    >
                                                        View
                                                    </button>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <p className="text-muted" style={{ fontSize: '16px' }}>No conversations found</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Conversation Modal */}
            <div className="modal fade" id="conversationModal" tabIndex="-1">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content" style={{ backgroundColor: '#1a2332', border: '1px solid #2d3748' }}>
                        <div className="modal-header">
                            <h5 className="modal-title text-white" style={{ fontSize: '20px' }}>
                                Conversation - {selectedConversation && moment(selectedConversation.date).format('MMM DD, YYYY hh:mm A')}
                            </h5>
                            <button
                                type="button"
                                className="btn-close btn-close-white"
                                data-bs-dismiss="modal"
                                onClick={handleModalClose}
                            ></button>
                        </div>
                        <div className="modal-body" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                            {selectedConversation && Array.isArray(selectedConversation.conversation) ? (
                                <div className="conversation-messages">
                                    {selectedConversation.conversation.map((msg, index) => (
                                        <div key={index} className={`mb-3 ${msg.role === 'ai' ? 'text-end' : 'text-start'}`}>
                                            <div
                                                className={`d-inline-block p-3 rounded ${msg.role === 'ai'
                                                    ? 'bg-primary text-white'
                                                    : 'bg-secondary text-white'
                                                    }`}
                                                style={{ maxWidth: '80%' }}
                                            >
                                                <small className="d-block mb-1 opacity-75" style={{ fontSize: '13px' }}>
                                                    {msg.role === 'ai' ? 'AI Assistant' : 'Customer'}
                                                </small>
                                                <p className="mb-0" style={{ fontSize: '15px' }}>{msg.content}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <p className="text-muted" style={{ fontSize: '16px' }}>No conversation available</p>
                            )}
                        </div>
                        <div className="modal-footer">
                            {selectedConversation && selectedConversation.record && selectedConversation.record !== 'N/A' && (
                                <audio ref={audioRef} controls className="w-100">
                                    <source src={selectedConversation.record} type="audio/wav" />
                                    Your browser does not support the audio element.
                                </audio>
                            )}
                            <button
                                type="button"
                                className="btn btn-secondary"
                                data-bs-dismiss="modal"
                                onClick={handleModalClose}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                show={openModal}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                size="lg"
                centered
                className="dark-modal"
            >
                <Modal.Header closeButton className="bg-success text-white">
                    <Modal.Title>Update Customer</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="row g-2 mb-1">
                            <div className="mb-1 col-md-4">
                                <label className="form-label">
                                    Target Lead Name <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className={`form-control ${errors.target_lead_name ? "is-invalid" : ""}`}
                                    placeholder="Enter Target Lead Name"
                                    {...register("target_lead_name", {
                                        required: "Lead name is required",
                                        pattern: {
                                            value: /^[A-Za-z\s]+$/,
                                            message: "Lead name must contain only alphabets and spaces",
                                        },
                                        minLength: { value: 2, message: "Lead name must be at least 2 characters" },
                                    })}
                                />
                                {errors.target_lead_name && (
                                    <div className="invalid-feedback">{errors.target_lead_name.message}</div>
                                )}
                            </div>

                            <div className="mb-1 col-md-4">
                                <label className="form-label">
                                    Target Company Email <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="email"
                                    className={`form-control ${errors.target_lead_email ? "is-invalid" : ""}`}
                                    placeholder="Enter Target Email ID"
                                    {...register("target_lead_email", {
                                        required: "Email is required",
                                        pattern: {
                                            value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                            message: "Please enter a valid email address",
                                        },
                                    })}
                                />
                                {errors.target_lead_email && (
                                    <div className="invalid-feedback">{errors.target_lead_email.message}</div>
                                )}
                            </div>

                            <div className="mb-1 col-md-4">
                                <label className="form-label">
                                    Target Lead Phone <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className={`form-control ${errors.target_lead_phone ? "is-invalid" : ""}`}
                                    placeholder="Enter Target Phone Number"
                                    {...register("target_lead_phone", {
                                        required: "Phone number is required",
                                        pattern: {
                                            value: /^(\+\d{1,3}\s?)?[6-9]\d{9}$/,
                                            message: "Please enter a valid phone number",
                                        },
                                    })}
                                />
                                {errors.target_lead_phone && (
                                    <div className="invalid-feedback">{errors.target_lead_phone.message}</div>
                                )}
                            </div>

                            <div className="mb-1 col-md-6">
                                <label className="form-label">
                                    Target Company Name <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className={`form-control ${errors.target_lead_company ? "is-invalid" : ""}`}
                                    placeholder="Enter Company Name"
                                    {...register("target_lead_company", { required: "Company name is required" })}
                                />
                                {errors.target_lead_company && (
                                    <div className="invalid-feedback">{errors.target_lead_company.message}</div>
                                )}
                            </div>

                            <div className="mb-1 col-md-6">
                                <label className="form-label">
                                    Target Company Website <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="text"
                                    className={`form-control ${errors.target_company_website ? "is-invalid" : ""}`}
                                    placeholder="Enter Target Company Website"
                                    {...register("target_company_website", { required: "Website is required" })}
                                />
                                {errors.target_company_website && (
                                    <div className="invalid-feedback">{errors.target_company_website.message}</div>
                                )}
                            </div>

                            <div className="mb-1 col-md-6">
                                <label className="form-label">
                                    Agent <span className="text-danger">*</span>
                                </label>
                                <select
                                    className={`form-select ${errors.agent ? "is-invalid" : ""}`}
                                    {...register("agent", { required: "Agent selection is required" })}
                                >
                                    <option value="">Select Agent</option>
                                    {agents && agents.length > 0 ? (
                                        agents.map((a) => (
                                            <option key={a.agent_id} value={a.agent_id}>{a.agent_name}</option>
                                        ))
                                    ) : (
                                        <option value="">No agents available</option>
                                    )}
                                </select>
                                {errors.agent && <div className="invalid-feedback">{errors.agent.message}</div>}
                            </div>


                            <div className="mb-1 col-md-12">
                                <div className="d-flex justify-content-start align-items-center mb-2">
                                    <label className="form-label mb-0">
                                        Target Company Info <span className="text-danger">*</span>
                                    </label>
                                    <button
                                        type="button"
                                        className="btn btn-success rounded-pill ms-2 px-3 py-1 d-flex align-items-center"
                                        style={{
                                            backgroundColor: "#28a745",
                                            color: "#fff",
                                            fontWeight: "500",
                                            fontSize: "14px",
                                            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                                        }}
                                        onClick={handleGenerateInfo}
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <>
                                                <span
                                                    className="spinner-border spinner-border-sm me-2"
                                                    role="status"
                                                    aria-hidden="true"
                                                ></span>
                                                Generating...
                                            </>
                                        ) : (
                                            <>
                                                <i className="ri-magic-line me-1"></i> Generate with AI
                                            </>
                                        )}
                                    </button>
                                </div>

                                <textarea
                                    className={`form-control ${errors.target_company_info ? "is-invalid" : ""}`}
                                    rows="6"
                                    placeholder="Write company info or Generate with AI"
                                    {...register("target_company_info", { required: "Company info is required" })}
                                ></textarea>
                                {errors.target_company_info && (
                                    <div className="invalid-feedback">{errors.target_company_info.message}</div>
                                )}
                            </div>
                        </div>

                        <div className="text-center mt-3 d-flex justify-content-end gap-2">
                            <Button type="button" variant="dark" className="rounded-pill px-4" onClick={handleClose}>
                                Cancel
                            </Button>
                            <Button type="submit" variant="success" className="rounded-pill px-4" disabled={submitLoading}>
                                {submitLoading ? (
                                    <>
                                        <Spinner animation="border" size="sm" className="me-2" /> Saving...
                                    </>
                                ) : (
                                    'Save Customer'
                                )}
                            </Button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>

            {/* DELETE CONFIRM MODAL */}
            <Modal
                show={showDeleteModal}
                onHide={handledeleteClose}
                backdrop="static"
                keyboard={false}
                size="md"
                centered
                className="dark-modal"
            >
                <Modal.Header closeButton className="bg-success text-white">
                    <Modal.Title>Delete Customer</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="modal-body">
                        Are you sure you want to delete this record?
                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-secondary" onClick={() => setShowDeleteModal(false)}>
                            Cancel
                        </button>

                        <button className="btn btn-danger" onClick={handleDelete} disabled={loading}>
                            Delete
                        </button>
                    </div>

                </Modal.Body>
            </Modal>


        </>
    );
};

export default Customerinfo;
